import Chart from "../../components/chart/Chart";
import Featured from "../../components/featured/Featured";
import { Navbar } from "../../components/navbar/Navbar";
import { Sidebar } from "../../components/sidebar/Sidebar";
import Table from "../../components/table/Table";
import Widget from "../../components/widget/Widget";
import Reports from "../../components/Reports";
import "./Home.css";
import ProductsChart from "../../components/ProductsChart";

const Home = () => {
  return (
    <div className="home">
      <Sidebar />
      <div className="homeContainer" style={{marginTop:'0'}}>
        <Navbar />
     <div>
        <div className="widgets">
          <Widget type="user" />
          <Widget type="order" />
          <Widget type="earning" />
          <Widget type="balance" />
        </div>
        <div className="charts">
        <div class="feachers">    
        <Featured />
        </div>
        <div class="report">
          <Reports/>
        </div> 

       </div>
        <div className="listContainer">
          <div className="listTitle">Dernières transactions</div>
          <Table />     
        </div>
        <div className="listContainer">
          <ProductsChart/>
          </div>
      </div>
    </div>
    </div>
  );
};

export default Home;
